import { render, staticRenderFns } from "./edit-bulk-message-filters.vue?vue&type=template&id=4ce9fc7d&scoped=true&"
import script from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9fc7d",
  null
  
)

export default component.exports